import { createEvent } from 'effector';
import { type PayinTraderFilters } from '~/entities/payin';

export const setTradersFilter = createEvent<PayinTraderFilters>();
